import React, { useEffect, useRef } from 'react';

interface MagneticLinkI {
  text: string;
  url: string;
}

const MagneticLink: React.FC<MagneticLinkI> = ({ text, url }) => {
  const divRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = divRef.current;
    if (!el) return;

    // ✅ Verifica se il dispositivo ha un puntatore "fine" (es: mouse o trackpad)
    const hasFinePointer =
      typeof window !== 'undefined' &&
      window.matchMedia('(pointer: fine)').matches;

    // ❌ Se non ha un puntatore fine (es: touch), non attiviamo l'effetto
    if (!hasFinePointer) return;

    const options = {
      ease: 0.1,
      magneticForce: 0.3,
    };

    const mouse = { x: 0, y: 0 };
    const pos = { cx: 0, cy: 0, tx: 0, ty: 0, x: 0, y: 0 };
    let sizes = el.getBoundingClientRect();

    const resizeHandler = () => {
      sizes = el.getBoundingClientRect();
    };

    const mouseMoveHandler = (e: MouseEvent) => {
      mouse.x = e.pageX;
      mouse.y = e.pageY;

      pos.cx = sizes.left + sizes.width / 2;
      pos.cy = sizes.top + sizes.height / 2;

      const distX = (mouse.x - sizes.left) - sizes.width / 2;
      const distY = (mouse.y - sizes.top) - sizes.height / 2;

      pos.tx = distX - distX * (1 - options.magneticForce);
      pos.ty = distY - distY * (1 - options.magneticForce);
    };

    const mouseLeaveHandler = () => {
      pos.tx = 0;
      pos.ty = 0;
    };

    const render = () => {
      pos.x += (pos.tx - pos.x) * options.ease;
      pos.y += (pos.ty - pos.y) * options.ease;
      el.style.transform = `translateX(${pos.x}px) translateY(${pos.y}px)`;
    };

    const update = () => {
      render();
      requestAnimationFrame(update);
    };

    // Attiviamo l'effetto
    el.addEventListener('mousemove', mouseMoveHandler);
    el.addEventListener('mouseleave', mouseLeaveHandler);
    window.addEventListener('resize', resizeHandler);

    update();

    // Cleanup
    return () => {
      el.removeEventListener('mousemove', mouseMoveHandler);
      el.removeEventListener('mouseleave', mouseLeaveHandler);
      window.removeEventListener('resize', resizeHandler);
    };
  }, []);

  return (
    <div className="magnetic-link-wrapper" ref={divRef}>
      <a
        href={url}
        target="_blank"
        rel="noreferrer"
        className="font-style-5 bold"
      >
        {text} {text !== 'Resume' ? '↗' : '↓'}
      </a>
    </div>
  );
};

export default MagneticLink;
